import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ShowIfLoggedIn } from '../features/auth/auth_utils';
import LogoutButton from './LogoutButton';

export default function TopNavbarAuth() {
  return (
    <Navbar bg="light" expand="lg" className="shadow-sm fixed-top" style={{zIndex: 1050}}>
      <Container>
        <Navbar.Brand as={Link} to="/">Mutual Fund pNAV Calculator - Early Release</Navbar.Brand>
        <Nav className="ms-auto">
          <Nav.Link as={Link} to="/">Home</Nav.Link>
          <ShowIfLoggedIn>
            <LogoutButton />
          </ShowIfLoggedIn>
        </Nav>
      </Container>
    </Navbar>
  );
}

